// src/components/KanbanColumn.jsx
import { Box, Typography, Paper } from "@mui/material";
import KanbanCard from "./KanbanCard";

export default function KanbanColumn({
  column,
  cards,
  selectedCard,
  onCardClick,
  onCardAction, // Make sure to accept this prop
  updateCardStatus, // M
}) {
  console.log("KanbanColumn received props:", {
    onCardAction,
    updateCardStatus,
  });

  // Fallback handler to prevent errors if onCardAction is not provided
  const handleCardAction =
    onCardAction ||
    ((cardId, card, action) => {
      console.error("onCardAction not provided to KanbanColumn");
      return Promise.resolve(false);
    });

  // Set colors based on column title
  let headerBg = "#c6f6fa"; // default light blue
  let badgeBg = "#3ed6e7"; // default blue badge

  // Check column title and assign appropriate colors
  if (column.title === "Total CAR Open" || column.title?.includes("Open")) {
    headerBg = "#c6f6fa"; // light blue
    badgeBg = "#3ed6e7"; // blue badge
  } else if (
    column.title === "Total CAR Closed" ||
    column.title?.includes("Closed")
  ) {
    headerBg = "#e0e0e0"; // light gray
    badgeBg = "#9e9e9e"; // gray badge
  } else if (
    column.title === "Total CAR Past-Due" ||
    column.title?.includes("Past-Due")
  ) {
    headerBg = "#FFFFED"; // light red
    badgeBg = "#BA8E23 "; // red badge
  }

  // Other design variables from MRKanban.jsx
  const headerText = "#222";
  const headerFontWeight = 700;
  const headerFontSize = 20;
  const badgeColor = "#fff";
  const badgeFontWeight = 600;
  const badgeFontSize = 16;

  return (
    <Box sx={{ width: 400, m: 1 }}>
      {/* Header */}
      <Box
        sx={{
          bgcolor: headerBg,
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
          borderTop: `5px solid ${badgeBg}`,
          px: 3,
          py: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          boxShadow: "0 2px 8px 0 rgba(0,0,0,0.03)",
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: headerFontWeight,
            color: headerText,
            fontSize: headerFontSize,
          }}
        >
          {column.title}
        </Typography>
        <Box
          sx={{
            bgcolor: badgeBg,
            color: badgeColor,
            fontWeight: badgeFontWeight,
            fontSize: badgeFontSize,
            px: 2,
            py: 0.5,
            borderRadius: "16px",
            minWidth: 32,
            height: 28,
            boxShadow: "0 1px 4px 0 rgba(0,0,0,0.08)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {cards?.length || 0}
        </Box>
      </Box>

      {/* <Paper
        elevation={0}
        sx={{
          bgcolor: column.color || "#f5f5f5",
          p: 2,
          borderRadius: "8px 8px 0 0",
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          {column.title} ({cards.length})
        </Typography>
      </Paper>

      <Paper
        elevation={1}
        sx={{
          p: 1,
          flex: 1,
          bgcolor: "#ffffff",
          borderRadius: "0 0 8px 8px",
          overflowY: "auto",
          maxHeight: "calc(100vh - 230px)",
        }}
      ></Paper> */}

      {/* Card List */}
      <Box
        id={column.id}
        sx={{
          width: 400,
          overflowY: "auto",
          py: 2,
          px: 2,
          // p: 3,
          bgcolor: "#f8fafc",
          borderBottomLeftRadius: 12,
          borderBottomRightRadius: 12,
          boxShadow: "0 2px 8px 0 rgba(0,0,0,0.03)",
          maxHeight: "calc(100vh - 180px)",
        }}
      >
        {cards.map((card) => (
          <KanbanCard
            key={card.id}
            card={card}
            onClick={() => onCardClick(column.id, card)}
            isSelected={selectedCard && selectedCard.id === card.id}
            onCardAction={handleCardAction} // Pass the safe handler
            updateCardStatus={updateCardStatus}
          />
        ))}
      </Box>
    </Box>
  );
}
